(function() {
  var Config = {
    paths: {
      async: "lib/async",
      domReady: "lib/domReady",
      jquery: 'lib/ngpvanevents-jquery',
      'jquery-iecors': 'lib/jQuery.XDomainRequest',

      config: "config",

      settings: "app/settings",
      databag: 'app/databag',
      hooks: 'app/hooks',
      gmapsapi: 'app/gmapsapi',
      maps: "app/maps",
      maprenderer: "app/maprenderer",
    }
  }

  if (typeof window !== 'undefined' &&
      typeof window._TEST_MODE !== "undefined" && window._TEST_MODE === true) {

    Config.baseUrl = window.base_url;
    Config.basePath = window.base_path;

    require.config(Config);
    return true;
  }

  if (typeof define === "function") {
    define('config',[], function() {
      return Config;
    });
  }

  if (typeof module === "object") {
    module.exports = Config;
  }
  if (typeof exports === "object") {
    exports.RJSConfig = Config;
  }
  return Config;
})();


